import {Sex} from "../../api/generated/herd-animal";
import React, {PropsWithChildren} from "react";
import {Badge} from "@mui/material";
import {SexIcon} from "../../icons/SexIcon";

export const SexBadge = ({sex, children}: Readonly<PropsWithChildren<{ sex: Sex }>>) => (
    <Badge badgeContent={<SexIcon sex={sex}/>}>{children}</Badge>
);